import reducer, { EndpointStatusState } from "./reducers";
import * as endpointStatusOperations from "./operations";
export {
  endpointStatusOperations,
  EndpointStatusState
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/endpointStatus/index.ts